// src/core/domain/format.js

// Pure display formatting. No React, no styles, no I/O.

export const formatNumber = (value) => {
  if (value === undefined || value === null || isNaN(value)) return '—';
  return value.toFixed(2);
};

export const formatPercent = (value) => {
  if (value === undefined || value === null || isNaN(value)) return '—';
  return `${(value * 100).toFixed(1)}%`;
};

// Seconds → decimal minutes string (1 dp). Returns null for missing input
// so callers can conditionally render.
export const formatHeadwayMinutes = (seconds) => {
  if (seconds === undefined || seconds === null || isNaN(seconds)) return null;
  return (seconds / 60).toFixed(1);
};